import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { FacilityMechanics } from './FacilityMechanics';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

export const RouteBase = () => {
  const isCreditAgreementLoaded = useCreditAgreementStore((store) =>
    Boolean(store.creditAgreement),
  );

  return (
    <Skeleton isLoaded={isCreditAgreementLoaded}>
      {isCreditAgreementLoaded && <FacilityMechanics />}
    </Skeleton>
  );
};

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/implementations" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
